module.exports = __webpack_public_path__ + "img/home_banner.1d1d6218.png";